export const azureBasicClientAndTenantIdSteps = [
  {
    text:
      'Sign in to the <a href="https://portal.azure.com" target="_blank">Azure management portal</a> in a separate browser window.',
  },
  { text: 'Navigate to App Registrations, and then click on the “+ New Registration” button.' },
  {
    text: 'Fill in details for the Cloudnosys application, and then click Create.',
    list: [
      'Enter a suitable name for the application (e.g. cloudnosys-app).',
      'Select your supported account type, which determines who can use the application (Recommended (default): Accounts in this organizational directory only)',
      'Click on the Register button.',
    ],
  },
  {
    text: 'Go to the App created and select “API Permissions” from the blade.',
  },
  {
    text:
      'Click on “+ Add a permission”. Select "Microsoft Graph" then "Application Permissions" and add the following API permissions to your app, using search box.',
    list: ['Application.Read.All', 'Directory.Read.All'],
  },
  {
    text:
      'Now add the "Reader" role to the application, on the subscription you\'re using, by following these steps:',
    list: [
      'Go to Subscription and select “Access Control (IAM)” from the blade.',
      'Click on "+ Add" and select "Add Role Assignment".',
      'Select the “Reader” Role and click on “Next”.',
      'Click on "+ Select Members" and search for the application that you\'ve just created, using the Application name or ObjectID.',
      'Click on the application name and then Select.',
      'Now Click on the "Review + Assign" button to complete the RBAC role assignment process.',
    ],
  },
  {
    text:
      'Copy the Application (client) ID and the Tenant ID for Cloudnosys Azure cloud account details and paste them under the required fields underneath.',
  },
];

export const azureAdvancedClientAndTenantIdSteps = [
  {
    text:
      'Sign in to the <a href="https://portal.azure.com" target="_blank">Azure management portal</a> in a separate browser window.',
  },
  { text: 'Navigate to App Registrations, and then click on the “+ New Registration” button.' },
  {
    text: 'Fill in details for the Cloudnosys application, and then click Create.',
    list: [
      'Enter a suitable name for the application (e.g. cloudnosys-app).',
      'Select your supported account type, which determines who can use the application (Recommended (default): Accounts in this organizational directory only)',
      'Click on the Register button.',
    ],
  },
  {
    text: 'Go to the App created and select “API Permissions” from the blade.',
  },
  {
    text:
      'Click on “+ Add a permission”. Select "Microsoft Graph" then "Application Permissions" and add the following API permissions to your app, using search box.',
    list: ['Application.Read.All', 'Directory.Read.All'],
  },
  {
    text:
      'Now add the "Reader" role to the application, on the subscription you\'re using, by following these steps:',
    list: [
      'Go to Subscription and select “Access Control (IAM)” from the blade.',
      'Click on "+ Add" and select "Add Role Assignment".',
      'Select the “Reader” Role and click on “Next”.',
      'Click on "+ Select Members" and search for the application that you\'ve just created, using the Application name or ObjectID.',
      'Click on the application name and then Select.',
      'Now Click on the "Review + Assign" button to complete the RBAC role assignment process.',
    ],
  },
  {
    text:
      'Follow the steps mentioned in Step-4 and add (assign) the following roles to the App, one-by-one:',
    list: [
      'Disk Snapshot Contributor',
      'Network Contributor',
      'Virtual Machine Contributor',
      'Storage Account Contributor',
    ],
  },
  {
    text: 'Add (create) a Custom Role with the following permissions:',
    list: [
      'Microsoft.Resources/subscriptions/resourceGroups/write',
      'Microsoft.Resources/subscriptions/resourceGroups/delete',
    ],
  },
  {
    text: 'Add this custom role to the App as well.',
  },
  {
    text:
      'Copy the Application (client) ID and the Tenant ID for Cloudnosys Azure cloud account details and paste them into the required fields underneath.',
  },
];

export const azureBasicSecretKeyAndSubscriptionIdSteps = [
  {
    text: 'On the App registration page, select the application.',
  },
  {
    text: 'Select Certificates & Secrets from the menu on the left.',
  },
  {
    text:
      'Add a suitable description for the client’s secret and include the ‘expiry date’ (suggested: one year).',
  },
  {
    text: 'Click on the Add button to generate the Secret key ID.',
  },
  {
    text: 'Copy the “Secret Value” because you aren’t able to retrieve this later.',
  },
  {
    text: 'Paste the Secret Value into the required field underneath.',
  },
  {
    text: 'Now go to Subscription and copy the subscription ID where you’ve created the app.',
  },
  {
    text: 'Paste the subscription ID into the required field underneath.',
  },
];

export const azureAdvancedSecretKeyAndSubscriptionIdSteps = [
  {
    text: 'On the App registration page, select the application.',
  },
  {
    text: 'Select Certificates & Secrets from the menu on the left. ',
  },
  {
    text:
      'Add a suitable description for the client’s secret and include the ‘expiry date’ (suggested: one year).',
  },
  {
    text: 'Click on the Add button to generate the Secret key ID.',
  },
  {
    text: 'Copy the “Secret Value” because you aren’t able to retrieve this later.',
  },
  {
    text: 'Paste the Secret Value into the required field underneath.',
  },
  {
    text: 'Now go to Subscription and copy the subscription ID where you’ve created the app.',
  },
  {
    text: 'Paste the subscription ID into the required field underneath.',
  },
];
